import React, { useEffect, useState } from 'react';
import { Toast } from 'react-bootstrap';
import { motion } from 'framer-motion';
import './ToastNotification.css';
import NotificationPortal from '../PortalNotification/NotificationPortal';

const ToastNotification = ({ show, message, onClose, type }) => {
  const [isVisible, setIsVisible] = useState(show);
  const [isFirstRender, setIsFirstRender] = useState(true);

  useEffect(() => {
    if (show) {
      setIsVisible(true);
      setIsFirstRender(false);
    } else {
      const timer = setTimeout(() => setIsVisible(false), 500);
      return () => clearTimeout(timer);
    }
  }, [show]);

  const getToastStyle = () => {
    switch (type) {
      case 'success':
        return {
          backgroundColor: '#d4edda',
          borderColor: '#c3e6cb',
          color: '#155724',
          borderLeftColor: '#28a745'
        };
      case 'error':
        return {
          backgroundColor: '#f8d7da',
          borderColor: '#f5c6cb',
          color: '#721c24',
          borderLeftColor: '#dc3545'
        };
      case 'warning':
        return {
          backgroundColor: '#fff3cd',
          borderColor: '#ffeeba',
          color: '#856404',
          borderLeftColor: '#ffc107'
        };
      default:
        return {
          backgroundColor: '#e2e3e5',
          borderColor: '#d6d8db',
          color: '#383d41',
          borderLeftColor: '#6c757d'
        };
    }
  };

  const toastVariants = {
    hidden: { opacity: 0, x: 100 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 25
      }
    },
    exit: {
      opacity: 0,
      x: 100,
      transition: { duration: 0.2 }
    }
  };

  if (!isVisible && isFirstRender) return null;

  const style = getToastStyle();

  return (
    <NotificationPortal>
      <motion.div
        initial={isFirstRender ? false : "hidden"}
        animate={isVisible ? "visible" : "exit"}
        variants={toastVariants}
        className="position-fixed"
        style={{
          top: '20px',
          right: '20px',
          zIndex: 9999,
          minWidth: '300px',
          maxWidth: '400px',
          pointerEvents: 'auto'
        }}
      >
        <Toast
          show={true}
          onClose={onClose}
          delay={4000}
          autohide
          className="custom-toast shadow-lg"
          style={{
            borderLeft: `4px solid ${style.borderLeftColor}`,
            backgroundColor: style.backgroundColor,
            color: style.color,
            border: `1px solid ${style.borderColor}`
          }}
        >
          <Toast.Header className="custom-toast-header" style={{ backgroundColor: style.backgroundColor }}>
            <strong className="me-auto">
              {type === 'success' ? '✅' :
                type === 'error' ? '❌' :
                  type === 'warning' ? '⚠️' : 'ℹ️'}
              Уведомление
            </strong>
          </Toast.Header>
          <Toast.Body style={{ padding: '1rem', backgroundColor: style.backgroundColor }}>
            <div style={{
              fontWeight: 500,
              fontSize: '1rem',
              lineHeight: 1.4
            }}>
              {message}
            </div>
          </Toast.Body>
        </Toast>
      </motion.div>
    </NotificationPortal>
  );
};

export default ToastNotification;